export default function Route() {
  return (
    <div className="mx-auto max-w-2xl px-6 py-24 text-gray-900 sm:py-32 lg:px-8">
      <h1 className="mb-4 text-center text-4xl font-black">
        Terms and Conditions
      </h1>

      <h2 className="text-lg font-semibold">1. Introduction</h2>
      <p>
        By using Wordbrush, you confirm your acceptance of, and agree to be
        bound by, these terms and conditions.
      </p>

      <h2 className="mt-4 text-lg font-semibold">
        2. Agreement to Terms and Conditions
      </h2>
      <p>
        This Agreement becomes effective on the date you first use the Wordbrush
        application.
      </p>

      <h2 className="mt-4 text-lg font-semibold">
        3. Credit Package Software License with Termination Rights
      </h2>
      <p>
        The Wordbrush Software License allows users to purchase credit packages,
        enabling access to Wordbrush&apos;s functionalities on a per-use basis.
        Designed for writers and content creators, Wordbrush transforms written
        content into compelling images, enhancing storytelling and visual
        communication.
      </p>
      <p>
        This license offers a flexible approach, allowing users to choose how
        much they want to engage with the service based on their needs without
        the commitment to recurring fees or subscriptions. However, it&apos;s
        important to recognize that the licensor reserves the right to terminate
        the license at any time, without conditions. This provision ensures the
        licensor can manage software distribution and use effectively.
      </p>
      <p>
        Choosing the Wordbrush Software License means enjoying the innovative
        features of the application while acknowledging the licensor&apos;s
        right to terminate, ensuring flexibility and preparedness for any
        unforeseen circumstances.
      </p>

      <h2 className="mt-4 text-lg font-semibold">5. Disclaimer</h2>
      <p>
        It is not guaranteed that Wordbrush will meet all your requirements or
        operate without interruption or errors. All express or implied
        warranties or conditions not stated in this Agreement (including, but
        not limited to, loss of profits, data loss or corruption, business
        interruption, or loss of contracts), to the extent that exclusion or
        disclaimer is allowed under applicable law, are excluded and expressly
        disclaimed. This Agreement does not affect your statutory rights.
      </p>

      <h2 className="mt-4 text-lg font-semibold">
        6. Warranties and Limitation of Liability
      </h2>
      <p>
        Wordbrush does not offer any warranties, guarantees, or terms regarding
        the quality, fitness for purpose, or otherwise of the software.
        Wordbrush shall not be liable for any indirect, special, or
        consequential loss, damage, costs, expenses, or other claims (whether
        caused by Wordbrush&apos;s negligence or the negligence of its agents or
        otherwise) arising from or connected to the provision of any goods or
        services by Wordbrush. Notwithstanding any contrary clauses in this
        Agreement, in the event that Wordbrush is found liable for breach of
        this Agreement, our liability is limited to the amount you have actually
        paid for the services or software, as calculated based on this clause.
        You hereby release Wordbrush from any and all obligations, liabilities,
        and claims beyond this limitation.
      </p>

      <h2 className="mt-4 text-lg font-semibold">7. Responsibilities</h2>
      <p>
        Wordbrush is not responsible for the user-generated content created
        using the application.
      </p>

      <h2 className="mt-4 text-lg font-semibold">8. General Terms and Law</h2>
      <p>
        This Agreement is governed by the laws of the Dominican Republic. You
        acknowledge that no joint venture, partnership, employment, or agency
        relationship exists between you and Wordbrush as a result of your use of
        these services. You agree not to represent yourself as a representative,
        agent, or employee of Wordbrush and understand that Wordbrush will not
        be liable for any representation, act, or omission on your part.
      </p>

      <p className="mt-4 text-right">Last updated: February 23, 2024.</p>
    </div>
  )
}
